import { AppConfig } from '@aipb/env/util';
import { isUndefined } from '@aipb/util/other';
import { BrowserEnv } from './browser.env';

export class BrowserConfig extends AppConfig<BrowserEnv> {
  get supportsLorisThumb(): boolean {
    // @ts-expect-error foo
    return isUndefined(this.config.supportsLorisThumb) ? true : this.config.supportsLorisThumb;
  }

  get toolbarTimeout(): number {
    return this.config.toolbarTimeout || 1000;
  }

  get quickModeDomains(): string[] {
    return this.config.quickModeDomains || ['collectiones.manuscriptorium.com'];
  }

  get disableOpenManifestFromUrl(): boolean {
    return this.config.disableOpenManifestFromUrl || false;
  }

  get stripImageWidth(): number {
    return this.config.stripImageWidth || 70;
  }

  get stripImageContainerHeight(): number {
    return this.config.stripImageContainerHeight || 140;
  }

  get hideDetailPaginator(): boolean {
    return this.config.hideDetailPaginator || false;
  }

  get detailAnnotation() {
    return (
      this.config.detailAnnotation || {
        unselectedColor: '#2c13ff',
        selectedViaMouseColor: '#13ffcc',
        selectedViaSidenavColor: '#13ffcc'
      }
    );
  }

  get relationApiUrl() {
    return this.config.relationApiUrl;
  }
}
